import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Table,Form, Button } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import styles from './style.module.scss';
import ResalesRequestService from '../../services/resales-request';
import {maskDocument, documentType, maskZip} from 'helpers/document';
import { useParams } from 'react-router-dom';
import { setContext } from 'redux-saga/effects';
import ContactForm from './ContactForm';
import AddressForm from './AddressForm';
import ProfileForm from './ProfileForm';

const ResalesShow = () => {
  const [reports, setReports] = useState({data:[]});
  const [company, setCompany] = useState([]);
  const [info, setInfo] = useState({segment:[],client_type:[],bu:[]});
  const [erroRequired, setErroRequired] = useState({campos:[],erro:false})

  const [bus, setBus] = useState([]);
  const [saveBu, setSaveBu] = useState({functionSave:null,verificar:null})

  const [formEdit, setFormEdit] = useState(false);
  const [formChanges, setFormChanges] = useState(null);
  const [wasModified, setWasModified] = useState(false);
  const [messageErro, setMessageErro] = useState(false);

  useEffect(() => {
    if(localStorage.getItem('companyId')!=null){
      let info = ResalesRequestService.getInfoResale();
      info.then(data => {
        setInfo(data.data);
      })
      let company = ResalesRequestService.getResale(localStorage.getItem('companyId'));
      company
      .then(data => {
        data.data[0].vip = data.data[0].vip?(data.data[0].vip==1?true:false):0;
        data.data[0].sumo_status = data.data[0].sumo_status?(data.data[0].sumo_status==1?true:false):0;

        setReports(data);
      });
    } else {
      setMessageErro(true);
    }
  }, []);

  useEffect(() => {
    setCompany(reports.data[0]);
    if(reports.data[0] != null && formChanges == null){
      setFormChanges({ ...reports.data[0] });
    }
  }, [reports,formEdit,wasModified,formChanges,erroRequired]);

  const formCompany = ()=>{
    return (
      <>
        <Container fluid>
          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <Row>
                    <Col className="align-self-center">
                      <h3 className={styles.headerTitle}>
                        Dados de Revenda
                      </h3>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <hr className={styles.line} />
                    </Col>
                  </Row>
                  <Card>
                    <Card.Body>
                      <Container>
                        <Row>
                          <Col>
                            <p className="font-weight-bold">Dados cadastrais</p>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6}>
                            <Form.Group>
                              <Form.Label>Grupo:</Form.Label>
                              <Form.Control
                                as="input"
                                disabled={true}
                                value={company.name_group}
                                >
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xs={6}>
                            <Form.Group>
                              <Form.Label>Razão Social:</Form.Label>
                              <Form.Control
                                as="input"
                                type="text"
                                disabled={true}
                                value={company.name}
                                >
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xs={6}>
                            <Form.Group>
                              <Form.Label>Nome Fantasia:</Form.Label>
                              <Form.Control
                                as="input"
                                disabled={true}
                                value={company.alias}
                                >
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xs={6}>
                            <Form.Group>
                              <Form.Label>CNPJ:</Form.Label>
                              <Form.Control
                                as="input"
                                disabled={true}
                                value={company.document}
                                >
                              </Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Container>
                    </Card.Body>
                  </Card>
                  <Row>
                    <Col>
                      <hr className={styles.line} />
                    </Col>
                  </Row>  
                  <ProfileForm
                  reports={reports}
                  setReports={setReports}
                  info={info}
                  ></ProfileForm>
                  <Row>
                    <Col>
                      <hr className={styles.line} />
                    </Col>
                  </Row> 
                  <AddressForm
                    reports={reports}
                  ></AddressForm>
                  <Row>
                    <Col>
                      <hr className={styles.line} />
                    </Col>
                  </Row>
                  <ContactForm>
                  </ContactForm>
                </Card.Body> 
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  };

  const showMessageErro = ()=>{
    return (
      <>
        <Container fluid>
          <Row>
            <Col className="col-12 d-flex justify-content-center my-5">
              <Card className="card border border-dark text-center col-8">
                <Card.Body>
                  <Row>
                    <Col className="col-12 align-self-center p-5">
                      <h3 className="text-black mb-4 px-4">Você precisa selecionar uma revenda para visualizar os dados.</h3>
                      <a className="btn btn-primary btn-lg" href="./" role="button" onClick={()=>{
                        localStorage.setItem('returnPage',window.location.href);
                      }}>Selecionar Revenda</a>
                    </Col>
                  </Row>
                </Card.Body> 
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  };
return (<>{
  company!=null?formCompany():
  <>{messageErro?showMessageErro():<></>}</>
  }</>);
};

export default MasterPage(ResalesShow);